import { getRecoil, setRecoil } from "recoil-nexus";
import userDetailsState from "../../atoms/userDetails";
import { socket } from "../index";
import { UserDetail } from "../type";

const listenReceiveUserDetails = () => {
  socket?.on('RECEIVE_USERS_DETAIL', (userDetails: UserDetail[]) => {
    const _userDetails = getRecoil(userDetailsState);

    const newUserDetails = new Map(_userDetails);
    userDetails.forEach((userDetail) => {
      newUserDetails.set(userDetail.id, userDetail);
    });
    setRecoil(userDetailsState, newUserDetails);
  });
}

export default listenReceiveUserDetails;